module.exports = __webpack_public_path__ + "img/loading.8da3562e.png";